// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layouts_layout__1sT0t","header":"Layouts_header__jvnUQ","content":"Layouts_content__N3E98"};